import { render, staticRenderFns } from "./Card5.vue?vue&type=template&id=2909f7b2&scoped=true&"
import script from "./Card5.vue?vue&type=script&lang=js&"
export * from "./Card5.vue?vue&type=script&lang=js&"
import style0 from "./Card5.vue?vue&type=style&index=0&id=2909f7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909f7b2",
  null
  
)

export default component.exports